import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Process from './components/Process';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Admin from './components/Admin';

// Main website layout
const MainSite = () => (
  <>
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Projects />
      <Process />
      <Team />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/jeeva-admin-2024" element={<Admin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
